// Блокировка скролла

import { throttle } from './ThrottleDebounce.js';

const ios = App.H.is('.ios');
const $header = $('.js-header');
let scroll = 0;


export function lock() {
    scroll = App.W.scrollTop();
    const w = App.B.width();
    console.log(scroll);

    App.H.addClass('_noscroll');
    App.B.addClass('_noscroll').css({'width': w});
    $header.css({'width': w});

    if (ios) {
		const h = App.W.height();
		App.B.height(h + 100);
	}
}



export function unlock() {
    App.H.removeClass('_noscroll');
    App.B.removeClass('_noscroll').css({'width': 'auto'});
    $header.css({'width': '100%'});

    //if (ios) {
		App.W.height('');
		App.W.scrollTop(scroll);
	//}
}



App.W.on('resize', throttle(function() {
    if (App.B.hasClass('_noscroll')) {
        App.B.css({'width': App.W.width()});
        $header.css({'width': App.W.width()});
    }
}, 100));



// WEBPACK FOOTER //
// ./_src/js/modules/LockScroll.js